"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearAllSessionStorageKeys = void 0;
var _sessionStorageKeyPrefix = require("../constants/sessionStorageKeyPrefix");
const clearAllSessionStorageKeys = () => {
  for (const [key] of Object.entries(sessionStorage)) {
    if (key.startsWith(_sessionStorageKeyPrefix.SESSION_STORAGE_KEY_PREFIX)) {
      sessionStorage.removeItem(key);
    }
  }
};
exports.clearAllSessionStorageKeys = clearAllSessionStorageKeys;
